// icons
export const ROUTE_COLUMN_ICONS = {
  // route
  "probable-categories": {
    // columns
    type: {
      // icon map
      ACUTE: "navigation",
      CHRONIC: "refreshCounterClockwise",
    },
    probability: {
      // icon map
      LOW: {
        icon: "hexagon",
        style: {
          "stroke-width": 2,
          color: "rgb(216, 64, 64)",
          fill: "rgb(228, 121, 121)",
        },
      },
      MEDIUM: {
        icon: "triangle",
        style: {
          "stroke-width": 2,
          color: "rgb(255, 193, 7)",
          fill: "rgb(255, 211, 82)",
        },
      },
      HIGH: {
        icon: "circle",
        style: {
          "stroke-width": 2,
          color: "rgb(68, 173, 0)",
          fill: "rgb(125, 197, 78)",
        },
      },
    },
  },
  // route
  "current-categories": {
    // columns
    type: {
      // icon map
      ACUTE: "navigation",
      CHRONIC: "refreshCounterClockwise",
    },
    initialCreditSource: {
      // icon map
      CHART: "folder",
      CLAIM: "dollarSign",
    },
  },
};
